import { facetSetReducer as facetSet } from '../../../features/facets/facet-set/facet-set-slice.js';
import { updateFacetAutoSelection, } from '../generic/facet-actions.js';
import { deselectAllFacetValues, registerFacet, toggleExcludeFacetValue, toggleSelectFacetValue, updateFacetIsFieldExpanded, updateFacetNumberOfValues, updateFacetSortCriterion, updateFreezeCurrentValues, } from './facet-set-actions.js';
/**
 * Loads the `facetSet` reducer and returns possible action creators.
 *
 * @param engine - The headless engine.
 * @returns An object holding the action creators.
 *
 * @group Actions
 * @category FacetSet
 */
export function loadFacetSetActions(engine) {
    engine.addReducers({ facetSet });
    return {
        deselectAllFacetValues,
        registerFacet,
        toggleSelectFacetValue,
        toggleExcludeFacetValue,
        updateFacetIsFieldExpanded,
        updateFacetNumberOfValues,
        updateFacetSortCriterion,
        updateFreezeCurrentValues,
        updateFacetAutoSelection,
    };
}
